import { useEffect, useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { getTypeVehiclesService } from "../services/getTypeVehicles.service";

export const useTypeVehicles = (filters = {}) => {
  const fetchData = useFetch();
  const [typeVehicles, setTypeVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const loadTypeVehicles = async () => {
    try {
      setLoading(true);
      const data = await getTypeVehiclesService(fetchData)(filters);
      setTypeVehicles(data.datos);
    } catch (error) {
      console.error("Error loading type vehicles:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const debouncedLoad = debounce(() => loadTypeVehicles(), 300);
    debouncedLoad();
    return () => debouncedLoad.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  return {
    typeVehicles,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
